import { apiClient } from '@app/lib'
import { type VerifySoftwareTokenResponseType } from '@aws-sdk/client-cognito-identity-provider'
import { useMutation } from '@tanstack/react-query'
import { ApiResponse } from '@app/types'

export const useVerifySoftwareToken = () =>
  useMutation({
    mutationKey: ['verifySoftwareToken'],
    mutationFn: async (code: string) => {
      const { data } = await apiClient.post<ApiResponse<VerifySoftwareTokenResponseType>>(
        `/api/mfa/verify_software_token`,
        {
          code
        },
        {
          validateStatus: () => true
        }
      )

      return data
    }
  })
